import { render, staticRenderFns } from "./RecipeDialog.vue?vue&type=template&id=53d6e119&scoped=true"
import script from "./RecipeDialog.vue?vue&type=script&lang=js"
export * from "./RecipeDialog.vue?vue&type=script&lang=js"
import style0 from "./RecipeDialog.vue?vue&type=style&index=0&id=53d6e119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d6e119",
  null
  
)

export default component.exports